import { createAction } from '@reduxjs/toolkit';

export const resetPropertyIdentificationValue = createAction<{
  id: string;
  fieldName: string;
}>('resetPropertyIdentificationValue');
